import React from 'react';
import PreviewPane from '../preview/PreviewPane';

export default function Step7Preview() {
  return (
    <div className="flex flex-col h-full">
      <div className="px-6 pt-6 pb-3 flex-shrink-0">
        <h2 className="text-lg font-bold text-gray-900 mb-1">Preview</h2>
        <p className="text-sm text-gray-500">
          This is exactly how your PDF will look. Navigate pages with the arrows below.
        </p>
      </div>
      <div className="flex-1 min-h-0 border-t border-stone-100">
        <PreviewPane fullHeight />
      </div>
    </div>
  );
}
